import type { OrderMode, OrderType } from '../store/cart';

/**
 * The legacy numeric order_type the whole stack agrees on.
 *
 *   1 = walk-in / takeaway   2 = delivery   3 = dine-in
 *   4 = pickup               5 = membership (buy)
 *
 * These are the same five codes the admin offers when scoping a promotion or a
 * coupon (`apps/admin/src/features/promotions/shared.tsx` → ORDER_TYPES), and
 * the server matches a scoped promotion against exactly this number. So the
 * code the cart previews with and the code the sale is charged with must come
 * from one place: quote with 1 and charge with 3 and the cashier is shown a
 * discount the sale then refuses to give (or the reverse, which fails the
 * payment-sum check outright).
 */
export function orderTypeCodeFor(orderMode: OrderMode, orderType: OrderType): number {
  switch (orderMode) {
    case 'membership':
      return 5;
    case 'pickup':
      return 4;
    case 'dine-in':
      return 3;
    case 'delivery':
      return 2;
    default:
      // 'takeaway' — but honour the legacy `orderType` tag, which a recalled
      // parked order still sets on its own.
      return orderType === 'delivery' ? 2 : 1;
  }
}
